module.exports = __webpack_public_path__ + "assets/ic-coingecko.76763d73.svg";